import React from "react";
import { Remarkable } from "remarkable";
import { Button } from "@speedoc/design-assets";
import SectionHeading from "./sectionHeading";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";

const markdown = new Remarkable();
const HeroSlider = ({ content = {} }) => {
  const { sliders = [], linkUrl, linkText, linkCaption } = content;
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  const settings = {
    infinite: true,
    speed: 500,
    fade: false,
    autoplaySpeed: 6000,
    autoplay: true,
    dots: true,
    draggable: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)"
  };

  const scrollToNextSection = () => {
    if (linkUrl) {
      let div;
      try {
        div = document.querySelector(linkUrl);
        const topPoint = div.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ behavior: "smooth", left: 0, top: topPoint });
      } catch {
        return;
      }
    }
  };

  const ButtonLink = () => {
    const Container = ({ children }) => (linkUrl.includes("#") ? <>{children}</> : <a href={linkUrl}>{children}</a>);

    return (
      <Container>
        <Button type="button" className="primary sm" onClick={scrollToNextSection}>
          <span>{linkText}</span>
        </Button>
      </Container>
    );
  };

  return (
    <div id="heroSlider">
      <div className="heroSliderContent">
        <Slider {...settings}>
          {sliders.map(({ title, subtitle, description, image = {} }, i) => {
            return (
              <div key={i} className="slide">
                <div className="left">
                  <SectionHeading title={title} subtitle={subtitle} />
                  <div className="description" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
                </div>
                <div className="right">
                  <LazyLoadImage src={image?.url} alt={image?.alternativeText || ""} effect="blur" />
                </div>
              </div>
            );
          })}
        </Slider>
        <div className="bottom">
          <ButtonLink url={linkUrl} text={linkText} />
          {!isMobile && <div className="button-description">{linkCaption}</div>}
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
